import React from 'react'
import { FoundationsDropdown } from '../../GenericComponents/dropdown'
import { IBusinessParamsOptions } from '../Reports/VisualUnitParamsDialog'

const BusinessParamDropdown = (props: {id: string, bpdropDownOptions: IBusinessParamsOptions[], getBusinessParamsFn: any, part_index: number, enumHLSearchDataType: string}) => {
    const { id, bpdropDownOptions, getBusinessParamsFn, part_index, enumHLSearchDataType } = props;
  return (
      <select
          className='filtervalue-input-select'
          key={"BP_Select_" + part_index}
          id={id}
          onChange={(e) => getBusinessParamsFn(e.target.value, part_index)}>
          <option value={""}>--select--</option>
          {bpdropDownOptions.length > 0 &&
              bpdropDownOptions.map((itr: IBusinessParamsOptions, index: number) => {
                  return (
                      <option value={index}> {itr.Name}</option>
                  )
              })
          }
      </select>
  )
}

export default BusinessParamDropdown